<template>
  <div class="border border-gray-200 rounded-lg shadow-sm bg-white">
    <slot />
  </div>
</template>